
import { defineComponent } from '@nuxtjs/composition-api';
import { getOptimizedImage } from '~/helpers/getOptimizedImage';

export default defineComponent({
  name: 'JoinToSection',
  props: {
    title: {
      type: [String, Object],
      default: null,
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return { getOptimizedImage };
  },
});
